export const FETCH_DATA_ROOMLIST = `ROOM_LIST/FETCH_DATA`;
export const FETCH_DATA_ROOMLIST_REQUEST = `${FETCH_DATA_ROOMLIST}_REQUEST`;
export const FETCH_DATA_ROOMLIST_SUCCESS = `${FETCH_DATA_ROOMLIST}_SUCCESS`;
export const FETCH_DATA_ROOMLIST_FAILURE = `${FETCH_DATA_ROOMLIST}_FAILURE`;

export const SAVE_DATA_ROOMLIST = `ROOM_LIST/SAVE_DATA`;
export const SAVE_DATA_ROOMLIST_REQUEST = `${SAVE_DATA_ROOMLIST}_REQUEST`;
export const SAVE_DATA_ROOMLIST_SUCCESS = `${SAVE_DATA_ROOMLIST}_SUCCESS`;
